<template>
<div class="top-bar" :style="{ background:colors.paleYellow }" :class="{ 'top-bar__fixed': fixed }">
    <div class="top-bar__lang">
      <button-link 
        v-if="$i18n.locale == 'en'"
        :label="$t('turkish', 'tr') + '?'"
        @click="$setLocale('tr')"
        :fg="colors.coral"
        />
      <button-link
          v-if="$i18n.locale == 'tr'"
          :label="$t('english', 'en') + '?'"
          @click="$setLocale('en')"
          :fg="colors.coral"
          />
    </div>
    
    <div class="top-bar__links">
      <button-link
        :label="$t('rsvp')"
        @click="openRsvp"
        :fg="colors.coral"
        />
      <button-link
        :label="$t('registry')"
        @click="openRegistry"
        :fg="colors.coral"
        />
    </div>
    
</div>
</template>

<script>
import { colors } from '@/colors.js'
import ButtonLink from '@/components/ButtonLink.vue'

export default {
  name: 'TopBar',
  props: {
    fixed: { type: Boolean, default: false }
  },
  data () {
    return {
      colors,
    }
  },
  components: {
    ButtonLink,
  },
  methods: {
    openRegistry () {
      window.location.href = "https://www.amazon.com/wedding/dilara-semerci-regis-frey-pittsburgh-august-2019/registry/1Q3ANF9IWJY11"
    },
    openRsvp () {
      window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLSfC18iMMvddfDEkVpmzCIZjkjoGXsGLXseAQL9PYKtQe6ur3w/viewform';
    }
  },
}
</script>

<style lang="scss">
@import '@/colors.scss';

.top-bar {
    padding: 20px;
    display: flex;
    text-align: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    z-index: 8000;
    border-bottom: 2px solid $color-coral;
}
.top-bar__fixed {
    position: fixed;
}
.top-bar__lang {
    display: flex;
    // justify-content: flex-start;
}
.top-bar__links {
    display: flex;
    justify-content: flex-end;

    > * {
      margin-right: 15px;
    }

    > *:last-child {
      margin-right: 0;
    }
}
</style>
